<div
  class="full-page login-banner w-100"
  [style.background-image]="'url(' + ('login-registration/login-banner-image.png' | contentAssetImage) + ')'"
>
  <div class="container login-container">
    <div class="">
      <img [src]="'login-registration/fortress-logo.png' | contentAssetImage" alt="fortress-logo" width="300" height="auto" />
    </div>
    <div class="col-12 user-login-panel-content bg-white rounded-4 text-start">
      <h3 class="text-primary font-size-18 mb-3">{{ 'login.page.title' | translate }}</h3>
      <div class="text-primary panel-text mb-3 mlb-text font-size-14">
        {{ 'login.page.description' | translate }}
      </div>
      <fgb-user-login></fgb-user-login>
      <div class="d-flex align-items-center justify-content-center my-3">
        <hr class="me-4 text-disabled" />
        <div class="font-size-14 font-default text-info">Or</div>
        <hr class="ms-4 text-disabled" />
      </div>

      <div class="form-group">
        <a [routerLink]="['/register/new-member']">
          <div class="btn btn-white border btn-block create-account-button w-100 font-size-14 fw-bold">
            <span>{{ 'login.page.create.account.button' | translate }}</span>
          </div>
        </a>
        <a [routerLink]="['/register/friend']">
          <div class="btn btn-white border btn-block mt-3 create-account-button w-100 font-size-14 fw-bold">
            <span>{{ 'fgbcl.refer.a.friend' | translate }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="pb-5">
  <fgbcl-preview />
</div>
